export const PcSpWidth = {
  SMARTPHONE_MAX_WIDTH: 425,
  TABLET_MIN_WIDTH: 768,
  TABLET_MAX_WIDTH: 1400,
  // ↑わかりにくいので↓に変えていきたい
  MOBILE: 375,
  MOBILE_L: 600,
  TABLET: 768,
  LAPTOP: 1024,
  LAPTOP_L: 1400
}
